import React, { Component } from "react"
import { StaticQuery, graphql, Link } from "gatsby"

class ReviewList extends Component {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            allSanityReview {
              nodes {
                reviewText
                nameOfReviewer
              }
            }
          }
        `}
        render={data => {
          const reviews = data.allSanityReview.nodes.map((review, idx) => {
            return (
              <div className="reviewItem" key={review.nameOfReviewer}>
                <b>{review.nameOfReviewer}</b> - {review.reviewText}
              </div>
            )
          })

          return reviews
        }}
      />
    )
  }
}

export default ReviewList
